(function (window, document) {
  'use strict';

  function applyBackground(element, attribute) {
    var source = element.getAttribute(attribute);
    if (!source) return;
    element.style.backgroundImage = 'url("' + source.replace(/"/g, '%22') + '")';
    element.removeAttribute(attribute);
  }

  function initLazyBackgrounds() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-jr-bg]'));
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) { applyBackground(element, 'data-jr-bg'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        applyBackground(entry.target, 'data-jr-bg');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '900px 0px', threshold: 0.01 });

    elements.forEach(function (element) { observer.observe(element); });
  }

  function initHeroBackgrounds() {
    var slides = Array.prototype.slice.call(document.querySelectorAll('[data-jr-hero-bg]'));
    if (!slides.length) return;
    var delays = [700, 3500, 8500];
    slides.forEach(function (slide, index) {
      window.setTimeout(function () { applyBackground(slide, 'data-jr-hero-bg'); }, delays[index] || 1000);
    });
  }

  function boot() {
    initLazyBackgrounds();
    if (document.readyState === 'complete') initHeroBackgrounds();
    else window.addEventListener('load', initHeroBackgrounds, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
